import React from 'react';
import {
  GaugeContainer,
  useGaugeState,
} from '@mui/x-charts/Gauge';

const GaugeChart = ({ value }) => {  

  const SECTION_COLORS = [
    'var(--color-red)',
    'var(--color-greyDark)',
    'var(--color-green)',
  ];

  function polarToCartesian(cx, cy, radius, angleRadians) {
    return {
      x: cx + radius * Math.sin(angleRadians),
      y: cy - radius * Math.cos(angleRadians),
    };
  }
  
  function describeArc(cx, cy, radius, startAngle, endAngle) {
    const start = polarToCartesian(cx, cy, radius, startAngle);
    const end = polarToCartesian(cx, cy, radius, endAngle);
    const largeArcFlag = endAngle - startAngle <= Math.PI ? '0' : '1';
    return [
      `M ${start.x} ${start.y}`,
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${end.x} ${end.y}`,
    ].join(' ');
  }
  
  function CustomReferenceArcs() {
    const { cx, cy, innerRadius, startAngle, endAngle } = useGaugeState();
    const totalAngle = endAngle - startAngle;
    const sectionAngle = totalAngle / 3;
  
    return (
      <g>
        {[0, 1, 2].map((i) => {
          const a1 = startAngle + i * sectionAngle;
          const a2 = a1 + sectionAngle;
          const d = describeArc(cx, cy, innerRadius, a1, a2);
          return (
            <path
              key={i}
              d={d}
              fill="none"
              stroke={SECTION_COLORS[i]}
              strokeWidth={30}
            />
          );
        })}
      </g>
    );
  }

  function GaugePointer() {
    const { valueAngle, innerRadius, cx, cy } = useGaugeState();
  
    if (valueAngle === null) {
      return null;
    }
  
    const target = {
      x: cx + innerRadius * Math.sin(valueAngle),
      y: cy - innerRadius * Math.cos(valueAngle),
    };
    return (
      <g>
        <circle cx={cx} cy={cy} r={5} fill="var(--color-black)" />
        <path
          d={`M ${cx} ${cy} L ${target.x} ${target.y}`}
          stroke="var(--color-black)"
          strokeWidth={2.5}
        />
      </g>
    );
  }

  function GaugeArcLabels() {
    const { cx, cy, outerRadius, startAngle, endAngle } = useGaugeState();
    const labelRadius = outerRadius + 5;
  
    const arcPath = describeArc(cx, cy, labelRadius, startAngle, endAngle);
  
    return (
      <g>
        <path id="labelArc" d={arcPath} fill="none" stroke="transparent" />
  
        <text fontSize={12} fontFamily='var(--header-font)'>
          <textPath
            href="#labelArc"
            startOffset="0%"
            textAnchor="start"
            dominantBaseline="central"
            fill="var(--text-primary)"
          >
            Many blindspots
          </textPath>
        </text>
  
        <text fontSize={12} fontFamily='var(--header-font)'>
          <textPath
            href="#labelArc"
            startOffset="100%"
            textAnchor="end"
            dominantBaseline="central"
            fill="var(--text-primary)"
          >
            High awareness
          </textPath>
        </text>
      </g>
    );
  }

  return <GaugeContainer
    height={160}
    startAngle={-90}
    endAngle={90}
    value={value}
    valueMin={0}
    valueMax={1}
  >
    <CustomReferenceArcs />
    <GaugePointer />
    <GaugeArcLabels />
  </GaugeContainer>
};

export default GaugeChart;